export function findRoots(element?: Element | ShadowRoot | null) {
    if (!element) {
        return [];
    }
    const list: (Document | ShadowRoot)[] = []
    for (const el of [element, ...element.querySelectorAll('*')]) {
        if ('shadowRoot' in el && !!el.shadowRoot) {
            list.push(el.shadowRoot);
            list.push(...findRoots(el.shadowRoot));
        }
    }
    return list
}

// Element.closest() that traverses up the Shadow DOM recursively until it finds the selector or reaches the root
export function closest(root: Element, selectors: string): Element | null {
    function getNext(el: Element | Window | Document, next = el && 'closest' in el && el.closest(selectors)): Element | null {
        if (el instanceof Window || el instanceof Document || !el) {
            return null;
        }

        return next ? next : getNext((el.getRootNode() as ShadowRoot).host);
    }

    return getNext(root);
}

export function getSlot(element: Element, slot: string) {
    let span = element.querySelector(`[slot="${slot}"]`) as HTMLSpanElement;
    if (!span) {
        span = document.createElement("span");
        span.slot = slot;
        element.appendChild(span);
    }
    return span;
}

export async function closeOnBackdropClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Close the dialog when clicking on the background
    if (target instanceof HTMLDialogElement && target.hasAttribute('open')) {
        const rect = target.getBoundingClientRect()
        if (event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom) {
            return; // Click is inside the dialog content, do not close
        }
        event.preventDefault();
        event.stopPropagation();
        const focusableChild = target.querySelector('button,input,[tabindex]') as HTMLButtonElement | null;
        if (focusableChild && (!document.activeElement || document.activeElement.closest('dialog') !== target)) {
            // But the focus inside the dialog before closing it.
            // This is to ensure that the dialog closes properly in Chrome (jumps when migrating from the top-layer to its normal place)
            focusableChild.focus();
            await Promise.resolve()
            target.close();
        } else {
            target.close();
        }
    }
}
